module.exports = __webpack_public_path__ + "static/media/gallery-7.5e88f6c9.jpg";